import { LeftOutlined, RightOutlined } from "@ant-design/icons";
import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import Product from "../Product";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { fetchProducts } from "../../redux/ecommerce/productsSlice";

const NewArrivals = () => {
  const { t, i18n } = useTranslation();
  const { language } = i18n;

  const dispatch = useDispatch();

  const { products, statusPro, errorPro } = useSelector(
    (state) => state.products
  );

  useEffect(() => {
    if (statusPro === "succeeded") {
      dispatch(fetchProducts({ status: "recent", category_id: "" }));
    }
  }, [statusPro, dispatch]);

  const onChange = (key) => {
    console.log(key);
  };


  if (statusPro === "loading") {
    return (
      <p className="text-center text-xl text-[#FE9B71] col-span-2 mt-7 pt-7">
        Loading products...
      </p>
    );
  }

  return (
    <div className="px-20 max-lg:px-5 my-10">
      <div className="flex justify-between items-center mb-5">
        <h3 className="text-[#14294F] text-3xl max-lg:text-2xl font-semibold">
          {t("New Arrivals")}
        </h3>
        <Link
          to="/store"
          className="text-[#FE9B71] rounded-full border-4 border-[#FE9B71] w-[230px] max-lg:w-[180px] h-[50px] text-xl max-lg:text-lg flex items-center justify-center font-semibold"
        >
          {language == "en" ? (
            <>
              {t("Explore Store")}
              <RightOutlined className="ml-5 max-lg:ml-5 font-bold" />
            </>
          ) : (
            <>
              {t("Explore Store")}
              <LeftOutlined className="mr-5 max-lg:mr-5 font-bold" />
            </>
          )}
        </Link>
      </div>

      <div className="grid grid-cols-3 max-lg:grid-cols-1 gap-14 mt-10 mx-14 max-lg:mx-5">

        {products.map((product, idx) => (
          <Product
            key={idx}
            id={product.id}
            color_id={product.colors[0]?.id || null}
            count={1}
            image={`https://ecommerce.samoolah.com${product.image}`}
            name={language === "en" ? product.name_en : product.name_ar}
            price={product.price}
            link={product.id}
          />
        ))}

        {/* {chunk.map((product, idx) => (
        <Product
          key={idx}
          id={product.id}
          color_id={product.colors[0]?.id || null}
          count={1}
          image={`https://ecommerce.samoolah.com${product.image}`}
          name={language === "en" ? product.name_en : product.name_ar}
          price={product.price}
          link={product.id}
        />
      } */}

      </div>
    </div>
  );
};

export default NewArrivals;